import { createStore, combineReducers } from "redux";
import { userReducer } from "./User/UserReducer";

const reducers = combineReducers({ userReducer });

export const store = createStore(reducers);
